import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import {ContactWithID, RepairRequest} from '../../types/request.type';
import dayjs, { Dayjs } from 'dayjs';


type RepairInsertState = {

    repair_request: RepairRequest,
    loading: boolean,
    success: boolean,
    error: string | null;

  }
  
export const initRepairsResponse: RepairRequest = {
      id: 0,
      request_date: '',
      request_type: {
          id: 1,
          title: 'Гарантийная',
          project_code: ''
      },
      num: 15,
      client: {
          id: 0,
          title: ''
      },
      client_contacts: [],
      external_num: '381-4/24648',
      wagon_type: {
          type: 'staff',
          title: 'Штабной'
      },
      wagon_number: '111-14566',
      staff_wagon_number: '111-11111',
      wagon_build_date: String((dayjs('2022-04-17').format('YYYY-MM-DD'))),
      route_number: '1/2',
      route: 'Москва - Грозный',
      appearance: {
          time_arrival: String((dayjs('11.09.2023 09:00').format('DD.MM.YYYY HH:mm'))),
          time_departure: String((dayjs('10.09.2023 09:00').format('DD.MM.YYYY HH:mm'))),
          station: 'Москва-Киевская'
      },
      problems: 'Не работает УПАС' ,
      complete_date: String((dayjs('2020-04-17').format('YYYY-MM-DD'))),
      result: {
          done: 'Заменен УПАС',
          problems: 'Отсутсвует сим-карта GSM',
          description: 'Замена'
      },
      executor: 'Депо',
      wagon_contacts: []
  }
  const initialState: RepairInsertState = {

    repair_request: initRepairsResponse,
    loading: false,
    success: false,
    error: ""
  
  }

//const [wagon_number, setWagonNumber] = React.useState<string>('111-14566');

  const repairRequestSlice = createSlice({
    name: 'repair_request',
    initialState: initialState,
    reducers: {
      // Обычные редьюсеры
     
     
      setWagonNumber(state, action: PayloadAction<string>) {
        const stateNew = state;
        stateNew.repair_request.wagon_number = action.payload;
        state = stateNew; 
      },

      setStaffWagonNumber(state, action: PayloadAction<string>) {
     //   console.log(action.payload)
        const stateNew = state;
        stateNew.repair_request.staff_wagon_number = action.payload;
        state = stateNew; 
      },

      setRoute(state, action: PayloadAction<string>) {
        const stateNew = state;
        stateNew.repair_request.route = action.payload;
        state = stateNew; 
      },

      setStation(state, action: PayloadAction<string>) {
        const stateNew = state;
        stateNew.repair_request.appearance.station = action.payload;
        state = stateNew; 
      },

      setProblems(state, action: PayloadAction<string>) {
        const stateNew = state;
        stateNew.repair_request.problems = action.payload;
        state = stateNew; 
      },


      setResultProblems(state, action: PayloadAction<string>) {
        const stateNew = state;
        stateNew.repair_request.result.problems = action.payload;
        state = stateNew; 
      },

      setDescription(state, action: PayloadAction<string>) {
        const stateNew = state;
        stateNew.repair_request.result.description = action.payload;
        state = stateNew; 
      },

      setExecutor(state, action: PayloadAction<string>) {
        const stateNew = state;
        stateNew.repair_request.executor = action.payload;
        state = stateNew; 
      },

      setDone(state, action: PayloadAction<string>) {
        const stateNew = state;
        stateNew.repair_request.result.done = action.payload;
        state = stateNew; 
      },

      setWagonTypeId(state, action: PayloadAction<string>) {
        const stateNew = state;
        stateNew.repair_request.wagon_type.type = action.payload;
        state = stateNew; 
      },

      setWagonType(state, action: PayloadAction<string>) {
        const stateNew = state;
        stateNew.repair_request.wagon_type.title = action.payload;
        state = stateNew; 
      },


      setExternalNum(state, action: PayloadAction<string>) {
        const stateNew = state;
        stateNew.repair_request.external_num = action.payload;
        state = stateNew; 
      },

      setRouteNumber(state, action: PayloadAction<string>) {
        const stateNew = state;
        stateNew.repair_request.route_number = action.payload;
        state = stateNew; 
      },


      setRequestTypeId(state, action: PayloadAction<number>) {
        const stateNew = state;
        stateNew.repair_request.request_type.id = action.payload;
        state = stateNew; 
      },

      setRequestType(state, action: PayloadAction<string>) {
        const stateNew = state;
        stateNew.repair_request.request_type.title = action.payload;
        state = stateNew; 
      },

      setNum(state, action: PayloadAction<number>) {
        const stateNew = state;
        stateNew.repair_request.num = action.payload;
        state = stateNew; 
      },


      //const [wagon_build_date, setWagonBuildDate] = React.useState<Dayjs | null>(dayjs('2022-04-17'));

      setWagonBuildDate(state, action: PayloadAction<Dayjs | null>) {
        const stateNew = state;
        stateNew.repair_request.wagon_build_date = ((dayjs(action.payload).format('YYYY-MM-DD')));
        state = stateNew; 
      },


     // const [time_arrival, setTimeArrival] = React.useState<Dayjs | null>(dayjs('12.09.2023 09:00'));

      setTimeArrival(state, action: PayloadAction<Dayjs | null>) {
        const stateNew = state;
        stateNew.repair_request.appearance.time_arrival = ((dayjs(action.payload).format('DD.MM.YYYY HH:mm')));
        state = stateNew; 
      },


      //const [time_departure, setTimeDeparture] = React.useState<Dayjs | null>(dayjs('12.09.2023 09:00'));

      setTimeDeparture(state, action: PayloadAction<Dayjs | null>) {
        const stateNew = state;
        stateNew.repair_request.appearance.time_departure = ((dayjs(action.payload).format('DD.MM.YYYY HH:mm')));
        state = stateNew; 
      },


      setCompleteDate(state, action: PayloadAction<Dayjs | null>) {
        const stateNew = state;
        stateNew.repair_request.complete_date = ((dayjs(action.payload).format('YYYY-MM-DD')));
        state = stateNew; 
      },

      setClientContacts0(state, action: PayloadAction<ContactWithID[]>) {

        const stateNew = state;
        stateNew.repair_request.client_contacts = action.payload;

        state = stateNew; 
      },

      setWagonContacts0(state, action: PayloadAction<ContactWithID[]>) {

        const stateNew = state; 
        stateNew.repair_request.wagon_contacts = action.payload;
        state = stateNew; 
      },

      setReset: (state) => {

        const stateNew = state;
        stateNew.repair_request = initialState.repair_request;
        state = stateNew; 
      
      },

  

    },

})

export const {setWagonNumber, setStaffWagonNumber, setRoute, setStation, setProblems, setResultProblems, setDescription, setExecutor, setDone, setWagonType, setWagonTypeId, setExternalNum, setRouteNumber, setRequestTypeId, setRequestType, setNum, setWagonBuildDate, setTimeArrival,  setCompleteDate, setTimeDeparture, setClientContacts0, setWagonContacts0, setReset} = repairRequestSlice.actions;

export const repairRequestReducer = repairRequestSlice.reducer;